import { Component, inject } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslocoPipe } from '@ngneat/transloco';
import { RouteFormDateSelectorService } from './services/route-form-date-selector.service';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { DATE_SELECTOR_OPTIONS, LeaveNowOption, leaveAtOption, ArriveAtOption  } from './constants/date-selector-options.constant';
import { NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DateOptionFormComponent } from './components/date-option-form/date-option-form.component';


@Component({
  selector: 'app-route-form-date-selector',
  standalone: true,
  imports: [CommonModule, DateOptionFormComponent, MatButtonModule, MatIconModule, NgxMatTimepickerModule, NgFor, MatButtonToggleModule, TranslocoPipe, MatDatepickerModule, MatNativeDateModule, MatInputModule, FormsModule],
  templateUrl: './route-form-date-selector.component.html',
  styleUrls: ['./route-form-date-selector.component.scss']
})
export class RouteFormDateSelectorComponent {
  
  public routeFormDateSelectorService = inject(RouteFormDateSelectorService);
  public currentDate = new Date();
  public currentHour = this.routeFormDateSelectorService.getCurrentHour();
  
  public dateOptionSelected = this.routeFormDateSelectorService.dateOptionSelected;
  
  public leaveNowDate = this.routeFormDateSelectorService.leaveNowDate;
  public leaveNowHour = this.routeFormDateSelectorService.leaveNowHour;

  public leaveAtDate = this.routeFormDateSelectorService.leaveAtDate;
  public leaveAtHour = this.routeFormDateSelectorService.leaveAtHour;

  public arriveAtDate = this.routeFormDateSelectorService.arriveAtDate;
  public arriveAtHour = this.routeFormDateSelectorService.arriveAtHour;

  public dateSelectorOptions = DATE_SELECTOR_OPTIONS
  public leaveNowId = LeaveNowOption.id;
  public leaveAtId = leaveAtOption.id;
  public arriveAtId = ArriveAtOption.id;

  public toggleChanged(event:any) {
    if(event.value.id === this.leaveNowId) {
      this.leaveNowDate.set(new Date())
      this.leaveNowHour.set(this.routeFormDateSelectorService.getCurrentHour())
    } 
  }

}
